import React from 'react';

import {openSampleEntry} from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import FeaturePreviewScreen from './FeaturePreviewScreen';
import * as NewUserFlowActions from './NewUserFlowActions';

export const ENTRY_INFO_HEADER = 'Introducing entries';
const ENTRY_FEATURE_INFOS = [
  {
    header: 'Capture ideas, data, and papers in one place',
    text: `
      Drop in images and sequences directly to your entries. Add PDFs or presentations next to your
      notes to access them from anywhere.
    `,
    imageName: 'capture-images.gif',
  },
  {
    header: 'Find anything\u2014just @-mention it',
    text: `
      Instantly reference any of your files and link them to your entry. Start typing @ in any entry to
      search your files on Benchling.
    `,
    imageName: 'at-mention.gif',
  },
  {
    header: 'Plan your experiment',
    text: `
      Break out your to-do list by day and check them off as they get done. See what experiments you have
      going on this month on the home calendar.
    `,
    imageName: 'plan-experiment.gif',
  },
];

const handleClickNextScreen = () => {
  analytics.track('onboarding_page', 'clicked', {
    page: 'notebook_overview',
    objectClicked: 'button',
    objectText: 'Next',
    eventLastModified: 'FY21_Q1a2',
  });
  NewUserFlowActions.hideScreen();
  openSampleEntry();
};

const handleChangeActiveSection = (activeFeatureInfoText) => {
  analytics.track('onboarding_page', 'clicked', {
    page: 'notebook_overview',
    objectClicked: 'button',
    objectText: activeFeatureInfoText,
    eventLastModified: 'FY21_Q1a2',
  });
};

const EntryInfoScreen = () => (
  <FeaturePreviewScreen
    header={ENTRY_INFO_HEADER}
    subheader={
      <span>
        Projects contain entries used to <strong>document experiments</strong>.
      </span>
    }
    featureInfos={ENTRY_FEATURE_INFOS}
    handleClickNextScreen={handleClickNextScreen}
    onChangeActiveSection={handleChangeActiveSection}
    backgroundImage="entry-illustration.png"
  />
);

export default EntryInfoScreen;
